import axios from 'axios';
import {SDLUtil} from './index';

const alertError = (message) => {
  SDLUtil.alert({
    title: 'Error',
    msg: message,
  });
}

const request = async (type, url, params) => {
  SDLUtil.showLoadingBar(true);

  let response;

  if ('get' == type) {
    response = await axios.get(url).catch(error => error);
  } else {
    response = await axios[type](url, params).catch(error => error);
  }

  if (response.data.error) {
    alertError(response.data.error.message);
  }

  SDLUtil.showLoadingBar(false);
  return response;
}

export default {
  get(url) {
    return request('get', url);
  },

  put(url, params) {
    return request('put', url, params);
  },

  post(url, params) {
    return request('post', url, params);
  },

  delete(url, params) {
    return request('delete', url, params);
  },
};



// WEBPACK FOOTER //
// ./src/utils/RequestUtil.js